export const WALKTHROUGH_VIDEOS = [
  {
    id: '9yzqdiyZO8w',
    title: 'Judge'
  },
  {
    id: 'Zd1A4ZnKH6I',
    title: 'Team'
  }
];
